// src/features/summary/summarySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import summaryService from "./summaryService";

// === Async Thunk ===
export const fetchSummaryCounts = createAsyncThunk(
  "summary/fetchCounts",
  async (_, thunkAPI) => {
    try {
      return await summaryService.getSummaryCounts();
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// === Slice ===
const initialState = {
  data: null,
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",
};

const summarySlice = createSlice({
  name: "summary",
  initialState,
  reducers: {
    resetSummary: (state) => {
      state.data = null;
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSummaryCounts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSummaryCounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(fetchSummaryCounts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { resetSummary } = summarySlice.actions;
export default summarySlice.reducer;
